import { combineReducers } from 'redux';

import { GET_PARENT_PETITIONS_SUCCESS } from '../Features/Dashboard/actionTypes';

import assignRootReducer from '../Features/ManagePetitions/reducer';
import dashboardReducer from '../Features/Dashboard/reducer';
import generateReducer from '../Features/GeneratePetitions/reducer';
import petitionReviewReducer from '../Features/ReviewSignatures/reducer';
import fieldReportReducer from '../Features/PetitionFieldReport/reducer';
import notificationsReducer from '../Features/Notifications/reducer';
import settingsReducer from '../Features/Settings/reducer';
import initiativeReducer from '../Features/Initiative/reducer';
import landingPagesReducer from '../Features/LandingPage/reducer';
import organizationsReducer from '../Features/Organizations/reducer';
import auth from '../Features/Auth/reducer';
import usersReducer from '../Features/Users/reducer';
import rolesReducer from '../Features/Roles/reducer';
import jurisdictionsReducer from '../Features/Jurisdictions/reducer';
import landingSuccessConfiguration from '../Features/LandingSuccessConfiguration/reducer';
import teams from '../Features/Teams/reducer';
import donateForms from '../Features/DonateForms/reducer';
import donations from '../Features/Donations/reducer';
import globalSelections from '../Features/GlobalSelections/reducer';
import labels from '../Features/Labels/reducer';
import categories from '../Features/Categories/reducer';
import customMethods from '../Features/CustomMethods/reducer';
import locations from '../Features/LocationsAndEvents/Locations/reducer';
import events from '../Features/LocationsAndEvents/Events/reducer';
import manageProspects from '../Features/ManageProspects/reducer';
import walkRouteReducer from '../Features/WalkRoute/reducer';
import registrationFormReducer from '../Features/RegistrationForm/reducer';
import recruitsReducer from '../Features/Recruits/reducer';
import batchScanAndUploadReducer from '../Features/BatchScanAndUpload/reducer';
import uploadAndScanReducer from '../Features/UploadAndScan/reducer';
import parentOrganizationSelectReducer from '../Shared/OrganizationsAssign/ParentOrganizationSelect/reducer';
import organizationUsersSelectReducer from '../Shared/OrganizationsAssign/OrganizationUsersSelect/reducer';
import organizationStagesReducer from '../Shared/OrganizationsAssign/OrganizationRow/Stages/reducer';
import organizationReviewChecklistReducer from '../Shared/OrganizationsAssign/OrganizationRow/ReviewChecklist/reducer';
import viewPetitionImagesReducer from '../Features/ViewPetitionImages/reducer';
import signatoryEntryFieldsReducer from '../Features/Initiative/Shared/InitiativeForm/SignatureEntryFields/reducer';
import auditsReducer from '../Features/ReviewPetitions/reducer';
import reportsReducer from '../Features/Reports/reducer';

const initialState = {
  sidebarShow: 'responsive',
  darkMode: localStorage.getItem('dark_mode'),
};

const baseReducer = (state = initialState, {
  type, roles, initiativeId, ...rest
}) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    case GET_PARENT_PETITIONS_SUCCESS:
      return { ...state, adminMode: initiativeId === 'admin' };
    case 'SET_ROLES':
      return { ...state, ...rest, roles };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  auth,
  base: baseReducer,
  initiative: initiativeReducer,
  landing: landingPagesReducer,
  landingSuccessConfiguration,
  dashboard: dashboardReducer,
  generate: generateReducer,
  assign: assignRootReducer,
  review: petitionReviewReducer,
  fieldReport: fieldReportReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
  organizations: organizationsReducer,
  users: usersReducer,
  roles: rolesReducer,
  jurisdictions: jurisdictionsReducer,
  walkRoute: walkRouteReducer,
  donations,
  donateForms,
  teams,
  globalSelections,
  labels,
  categories,
  customMethods,
  locations,
  events,
  manageProspects,
  registrationForm: registrationFormReducer,
  recruits: recruitsReducer,
  batchScanAndUpload: batchScanAndUploadReducer,
  uploadAndScan: uploadAndScanReducer,
  parentOrganizationSelectReducer,
  organizationUsersSelectReducer,
  organizationStagesReducer,
  organizationReviewChecklistReducer,
  signatoryEntryFieldsReducer,
  viewPetitionImages: viewPetitionImagesReducer,
  audits: auditsReducer,
  reports: reportsReducer,
});

export default rootReducer;
